<div class="w-full text-left p-1 ">
  <div *ngIf="edizione"
    class="p-12 rounded-xl shadow-lg w-full inline-grid grid-cols-1 gap-1 w-full" style="background-color: {{_bgColor}}">
    <div class="ml-4 block">
      <h1>{{edizione.nome}}</h1>&nbsp;
      <h2>registrazione singola presenza:</h2>
    </div>
    <div class="block mx-4 mt-8">
        <p><label class="mr-2">Code</label>
          <input autofocus #input size="40" name="_insertId" [(ngModel)]="_insertId" id="_insertId"  cdkFocusInitial type="text" (keyup.enter)="registra($event)"/></p>
          <p *ngIf="iscritto" class="ml-12 my-5">
            <span>{{iscritto.nome}} {{iscritto.cognome}}  </span><fa-icon class="svg-faButton" [icon]="faCheck" class="mr-1" ></fa-icon>
          </p>
    </div>
  </div>
</div>
<script type="text/javascript" language="JavaScript">
  document._insertId.listacode.focus();
</script>
